import {
  ArchiveRegular,
  BoxMultipleRegular,
  ListRegular,
} from '@fluentui/react-icons';
import type { ModuleDef } from '#src/app/navigation/module';

/** Arquivo morto: caixas físicas da área Fiscal (ver docs/product). */
export const archiveModule: ModuleDef = {
  path: 'arquivo',
  title: 'Arquivo',
  icon: ArchiveRegular,
  placement: 'main',
  pages: [
    {
      path: 'caixas',
      title: 'Caixas',
      description: 'Buscar, cadastrar e corrigir caixas, com o histórico.',
      icon: BoxMultipleRegular,
      permission: 'Boxes.Read',
      load: () =>
        import('#src/modules/archive/BoxesPage').then((m) => m.BoxesPage),
    },
    {
      path: 'descricoes',
      title: 'Descrições',
      description: 'Descrições de documentos usadas no cadastro de caixas.',
      icon: ListRegular,
      permission: 'Categories.Write',
      load: () =>
        import('#src/modules/archive/CategoriesPage').then(
          (m) => m.CategoriesPage,
        ),
    },
  ],
  routes: [
    {
      path: 'caixas/:id',
      title: 'Caixa',
      permission: 'Boxes.Read',
      load: () =>
        import('#src/modules/archive/BoxDetailPage').then(
          (m) => m.BoxDetailPage,
        ),
    },
  ],
};
